import React, { memo, useEffect, useState, useCallback } from 'react';
import { AutocompleteInput, RemoveClient } from 'components';
import { IClientsResponse } from 'types/clients';
import { Box, Flex, Grid, Text } from '@chakra-ui/layout';
import { setItemStorage } from 'services/storage';
import { AddClient } from './components';
import { FormHandles } from '@unform/core';
import { getAllClients } from 'services/client';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { Popover, PopoverTrigger, PopoverContent, Button } from '@chakra-ui/react';
import { colors } from '../../theme/colors';

const ClientsComponent: React.FC<{
  disableNewClient?: boolean;
  disabled?: boolean;
  initialClient?: IClientsResponse;
  formRef?: React.RefObject<FormHandles>;
}> = ({ disableNewClient, disabled, initialClient, formRef }) => {
  const [clients, setClients] = useState<{ name: string; id: React.ReactText }[]>([]);
  const [client, setClient] = useState<IClientsResponse>();
  const [isSetted, setIsSetted] = useState(false);
  const [selectClientName, setSelectClientName] = useState<string | undefined>('');
  const [selectClientId, setSelectClientId] = useState<number | undefined>();
  const [count] = useState(0);
  const handleGetData = async () => {
    try {
      const { data } = await getAllClients('');
      setClients(data);
    } catch (error) {}
  };

  useEffect(() => {
    handleGetData();
  }, [count]);

  useEffect(() => {
    if (!client && initialClient && !isSetted) {
      setClient(initialClient);
      setItemStorage('selectedClient', initialClient.id);
      setIsSetted(true);
    }
  }, [initialClient, client]);

  const handleSelectClient = (params: {
    optionValue: any;
    selectMethod: 'mouse' | 'keyboard' | null;
    isNewInput: boolean;
  }) => {
    const selectedClient = clients?.find(clientArr => clientArr.id === params.optionValue);
    const selectClientName = clients?.find(clientArr => clientArr.id === params.optionValue);
    setItemStorage('selectedClient', selectedClient?.id);
    setSelectClientName(selectClientName?.name);
    setSelectClientId(Number(selectClientName?.id));
  };

  const onRemoveClient = useCallback(() => {
    handleGetData();
    setClient(undefined);
    if (formRef) formRef.current?.clearField('client');
  }, [handleGetData, count]);

  return (
    <Flex>
      <Grid w="100%" templateColumns="repeat(1, 1fr)" gridGap="1rem">
        <Flex mb="-0.8rem">
          <Box w="100px">
            <Text as="h5" fontWeight="bold">
              Cliente
            </Text>
          </Box>
          <Box flex="1"></Box>
          <Box paddingLeft="60px">
            {!disableNewClient && <AddClient postCreateClient={handleGetData} />}
          </Box>
        </Flex>

        <AutocompleteInput
          placeholder="Digite o ID ou o nome do Cliente"
          returnAllOption
          name="client"
          disabled={disabled}
          optionLabel="name"
          optionValue="id"
          onSelectOption={handleSelectClient}
          options={
            clients
              ?.map(client => ({ name: client.name, id: client.id }))
              .sort((a, b) => {
                return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
              }) || []
          }
        />
        {selectClientName?.length !== 0 ? (
          <Flex
            w="100%"
            alignItems={'center'}
            p={'5px 10px'}
            borderRadius={'0.23rem'}
            mb={'1.5rem'}
            mt={'-1rem'}
            bg="#F2F2F2"
          >
            <Flex w="100%" justify={'flex-start'}>
              <Text as="p" mr={4} fontWeight={'bold'}>
                {selectClientId}
              </Text>
              <Text as="p" fontWeight={'bold'}>
                {selectClientName}
              </Text>
            </Flex>
            <Popover>
              <PopoverTrigger>
                <Button className="boxPopover" bg={'transparent'} p="0" width={'5px !important'}>
                  <BsThreeDotsVertical color={colors.brand.tertiary} />
                </Button>
              </PopoverTrigger>

              <PopoverContent
                className="cardEdit"
                left={'-7rem'}
                top={'-1rem'}
                p="5px 15px"
                boxShadow={'0px 2px 6px rgba(0, 0, 0, 0.25)'}
                color={'#000'}
                cursor={'pointer'}
                // onClick={() => DeleteClientForm()}
              >
                <RemoveClient onRemoveClient={onRemoveClient} />
              </PopoverContent>
            </Popover>
          </Flex>
        ) : (
          ''
        )}

        <Flex
          h="47px"
          mb="1rem"
          borderRadius="8px"
          mt="-1.5rem"
          background="brand.white200"
          display={client ? 'flex' : 'none'}
          alignItems="center"
          justifyContent="flex-start"
          px="16px"
        >
          <Text w="fit-content" as="h5" color="brand.gray600" fontSize="14px" fontWeight="bold">
            {client?.id}
          </Text>
          <Text ml="16px" flex={1} as="h5" color="brand.gray600" fontSize="14px" fontWeight="bold">
            {client?.name}
          </Text>
          <Box pointerEvents={disabled ? 'none' : undefined} paddingLeft="90px" w="100px">
            <RemoveClient onRemoveClient={onRemoveClient} />
          </Box>
        </Flex>
      </Grid>
    </Flex>
  );
};

export const Clients = memo(ClientsComponent);
